import React from "react";

export default function NoMatch() {
  return <div>Page not found</div>;
}
